import { Breadcrumb, Form, notification } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import AddNotification from "../templates/Notification/AddNotification";
import { useEffect, useState } from "react";
import {
  useNotificationStore,
  usePostNotification,
} from "../../stores/NotificationStore";
import dayjs from "dayjs";

const NotificationCreateEdit = () => {
  const [api, contextHolder] = notification.useNotification({ maxCount: 1 });
  const location = useLocation();
  const isEditPage = location.pathname.includes("edit");
  const [formData, setFormData] = useState({
    title: null,
    message: null,
    deliveryScheduleType: 0,
    notificationRedirectionType: 0,
    notificationImageType: 0,
    groupType: 0,
    groupIds: [],
    tierType: 0,
    tierIds: [],
    recurrenceInterval: "1",
    notificationRedirectionUrl: null,
    endRecurrenceType: 1,
    recurrenceType: 0,
  });
  const [form] = Form.useForm();
  const postNotification = usePostNotification();
  const {
    setState,
    notificationListData,
    isPutNotificationStatusSuccess,
    putNotificationStatusData,
    isPostNotificationSuccess,
    isPostNotificationError,
    isPostNotificationData,
  } = useNotificationStore();
  const navigate = useNavigate();

  const openNotificationWithIcon = (type, message) => {
    if (["success", "error"].includes(type)) {
      api[type]({
        message: "Notifications",
        description: message,
        duration: 3,
      });
    } else {
      console.error("Invalid notification type:", type);
    }
  };

  useEffect(() => {
    if (isPostNotificationSuccess) {
      openNotificationWithIcon("success", "Notification created successfully");
      setTimeout(() => {
        navigate("/notifications");
      }, 2000);
      setState({ isPostNotificationSuccess: false });
    }

    if (isPostNotificationError) {
      openNotificationWithIcon("error", isPostNotificationData);
      setState({
        isPostNotificationError: false,
        isPostNotificationData: null,
      });
    }
  }, [isPostNotificationSuccess, isPostNotificationError]);

  const handlePublish = () => {
    const payload = new FormData();

    payload.append("title", formData.title);
    if (formData.message) {
      payload.append("message", formData.message);
    }
    payload.append(
      "notificationRedirectionType",
      formData.notificationRedirectionType
    );
    if (formData.notificationRedirectionType == 1) {
      payload.append(
        "notificationRedirectionUrl",
        formData?.notificationRedirectionUrl
      );
    }
    payload.append(
      "groupIds",
      formData?.groupType == 0
        ? JSON.stringify([])
        : JSON.stringify(formData.groupIds)
    );
    payload.append(
      "tierIds",
      formData?.tierType == 0
        ? JSON.stringify([])
        : JSON.stringify(formData?.tierIds)
    );
    payload.append("deliveryScheduleType", formData.deliveryScheduleType);
    if (formData.deliveryScheduleType == 1) {
      payload.append("scheduledDateTime", formData.scheduledDateTime);
    }

    if (formData?.deliveryRecurrenceType == 2) {
      payload.append("recurrenceInterval", formData.recurrenceInterval);
      payload.append("recurrenceType", formData.recurrenceType);

      if (formData.endRecurrenceType != 1) {
        if (formData.endRecurrenceType == 2) {
          payload.append(
            "recurrenceEndDate",
            dayjs(formData.recurrenceEndDate).format("YYYY-MM-DD")
          );
        } else if (formData.endRecurrenceType == 3) {
          payload.append(
            "recurrenceMaxOccurrences",
            formData.recurrenceMaxOccurrences
          );
        }
      }
    }

    if (formData?.notificationImageType == 1) {
      payload.append("notificationImage", formData.notificationImage);
    }

    postNotification(payload);
  };

  return (
    <>
      {contextHolder}
      <Breadcrumb
        className="pb-6"
        items={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Notification",
            href: "/notifications",
          },
          {
            title: isEditPage ? "Edit Notification" : "Create Notification",
            href: isEditPage
              ? `/notifications/edit/${id}`
              : "/notifications/create",
          },
        ]}
      />
      <AddNotification
        formData={formData}
        setFormData={setFormData}
        form={form}
        handlePublish={handlePublish}
      />
    </>
  );
};

export default NotificationCreateEdit;
